module.exports = __webpack_public_path__ + "static/media/Dec 14 (130).2f4f85eb.JPG";